module.exports = __webpack_public_path__ + "static/markdown-00350945ef8364e8f1877013b88f0f92.png";